export default __webpack_public_path__ + "static/media/dragIcon.af319033.svg";